import { TicketIcon } from "lucide-react";

import { Column } from "../Column";

import { cn } from "../../lib/utils";

// Minted violet token with a ticket stamp — the shop's currency for
// incentives, drawn in the pet UI's hard-shadow pixel style. Deliberately not
// gold so it never reads as a coin.
export const StafferPetIncentiveToken = ({
  className,
  sizePx = 20,
}: {
  className?: string;
  sizePx?: number;
}) => {
  /* Render */
  const render = () => {
    return (
      <Column
        className={cn(
          "shrink-0 -rotate-6 items-center justify-center rounded-full border-2 border-slate-900 bg-gradient-to-br from-violet-300 via-violet-400 to-violet-600 shadow-[2px_2px_0_#172033]",
          className,
        )}
        style={{ height: sizePx, width: sizePx }}
      >
        <Column
          className="items-center justify-center rounded-full border border-dashed border-violet-900/70"
          style={{ height: sizePx * 0.76, width: sizePx * 0.76 }}
        >
          <TicketIcon
            className="rotate-6 text-violet-950"
            style={{ height: sizePx * 0.5, width: sizePx * 0.5 }}
          />
        </Column>
      </Column>
    );
  };

  return render();
};
